import React from 'react'
import Navbar from '../navbar/navbar'
import Profile from '../profile/profile'

const Homepage = () => {
  return (
    <div>
      <Navbar/>
      <Profile/>
    </div>
  )
}

export default Homepage
